<script setup lang="js">
const props = defineProps({text:String})
</script>

<template>
  <div>
    <div class="w-full bg-white">
      <div class="container mx-auto flex justify-center relative">
        <div class="w-full bg-[#161981] h-[0.1rem] absolute translate-y-1/2 top-1/2 px-24"></div>
        <text class="text-[1.2rem] md:text-[1.2rem] lg:text-4xl text-white px-4 md:px-4 lg:px-8 py-3
      w-1/3 text-justify
       bg-[#161981] rounded-full border border-[#707070] z-50 tracking-widest
" style="text-align-last: justify;">{{text}}</text>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>
